import React, { useState, useEffect } from "react";
import MLActionBar from "./MLActionBar/ActionBar";
import DynamicTable from "../../../components/Table/MTable";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer"; // Import your Footer component
import axios from "axios";
import { useSelector } from "react-redux";

const MLocation = () => {
  const [locations, setLocations] = useState([]);
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null); // To track selected row
  const { role } = useSelector((state) => state.auth);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const apiEndpoint = `${API_BASE_URL}/admin/mlocation/mlocations`;

  const columns = [
    { key: "LocationID", label: "Location ID" },
    { key: "LocationName", label: "Location Name" },
    { key: "LocationEmail", label: "Location Email" },
  ];

  // Fetch locations
  const fetchLocations = async () => {
    try {
      const response = await axios.get(apiEndpoint);
      setLocations(response.data);
      setFilteredLocations(response.data);
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  };

  // Handle search
  const handleSearch = (query) => {
    if (!query) {
      setFilteredLocations(locations);
    } else {
      setFilteredLocations(
        locations.filter((loc) =>
          loc.LocationName.toLowerCase().includes(query.toLowerCase())
        )
      );
    }
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <Header exportEndpoint={apiEndpoint} />

      {/* Main Content */}
      <div className="flex-grow p-4">
        <MLActionBar
          title="Location"
          rowKey="LocationID"
          deleteMessage="Are you sure you want to remove this location permanently?"
          fields={[
            { name: "LocationName", label: "Name", required: true },
            { name: "LocationEmail", label: "Email", type: "email" },
          ]}
          apiEndpoint={apiEndpoint}
          data={filteredLocations}
          selectedRow={selectedRow} // Pass selected row to ActionBar
          onRowSelect={setSelectedRow} // Set selected row when clicked
          onRefresh={fetchLocations}
          onSearch={handleSearch}
          userRole={role} // Pass the user role
        />
        
        {/* Table Heading */}
        <div className="mt-6 mb-2 text-center">
          <h3 className="text-xl font-semibold">Location Table</h3>
        </div>

        {/* Dynamic Table */}
        <div className="mt-4">
          <DynamicTable
            columns={columns}
            data={filteredLocations}
            selectedRow={selectedRow}
            onRowSelect={setSelectedRow}
            rowKey="LocationID"
            highlightColor="bg-green-100"
            noDataMessage="No units found."
          />
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default MLocation;
